import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Clock } from 'lucide-react';
import { businessInfo } from '../mockData';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_tire-wizard/artifacts/h82o40wz_file_000000004bdc71f59adfe6d7fae65f85.png"
              alt="Vargas Tire Truck Repair"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Professional mobile tire and auto repair services. We bring expert automotive care directly to your location.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={scrollToTop}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('tires')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Tires
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contact
                </button>
              </li>
              <li>
                <a
                  href="/apply-provider"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Become a Provider
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Tire Sales & Installation</li>
              <li>Oil Change Service</li>
              <li>Brake Repair</li>
              <li>Battery Service</li>
              <li>Roadside Assistance</li>
              <li>Vehicle Diagnostics</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a href="tel:3057724150" className="flex items-center text-gray-400 hover:text-white transition-colors text-sm">
                <Phone className="w-4 h-4 mr-2 flex-shrink-0" />
                (305) 772-4150
              </a>
              <a href="mailto:info@vargastireautorepair.com" className="flex items-center text-gray-400 hover:text-white transition-colors text-sm">
                <Mail className="w-4 h-4 mr-2 flex-shrink-0" />
                info@vargastireautorepair.com
              </a>
              <div className="flex items-start text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mr-2 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-white mb-1">Service Areas:</p>
                  <p className="mb-1"><strong>South Florida:</strong></p>
                  <p className="text-xs leading-relaxed">Miami-Dade, Broward, Palm Beach, Monroe, Collier, Lee, Charlotte, Sarasota, Manatee, Martin, St. Lucie & more</p>
                  <p className="mt-2"><strong>Now Serving North Florida:</strong></p>
                  <p className="text-xs">New Location: Jacksonville, FL</p>
                  <p className="text-xs">Servicing all of North Florida</p>
                </div>
              </div>
              <div className="flex items-center text-yellow-400 text-sm font-semibold mt-3">
                <Clock className="w-4 h-4 mr-2 flex-shrink-0" />
                24/7 Roadside Assistance - Anytime, Anywhere
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h4 className="font-semibold text-sm mb-3">Follow Us</h4>
              <div className="flex space-x-3">
                <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                  <Facebook className="w-4 h-4" />
                </a>
                <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                  <Instagram className="w-4 h-4" />
                </a>
                <a href="#" className="w-9 h-9 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors">
                  <Twitter className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Vargas Tire & Auto Repair. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="/admin/login" className="hover:text-white transition-colors">Admin</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};